import React from "react";
import Mark from "../assets/images/logo-mark.png";

// The CFCM logo (the globe with "cfcm" across it). There is no word beside it.
//   <BrandLogo />                 the logo
//   <BrandLogo light />           for dark backgrounds (the logo sits on a white plate)
//   <BrandLogo size={36} />       height of the logo in pixels
function BrandLogo({ size = 40, light = false }) {
    return (
        <span className={`cf-brand ${light ? "is-light" : ""}`}>
            <span className="cf-brand-plate">
                <img className="cf-brand-mark" src={Mark} alt="CFCM" style={{ height: size }} />
            </span>
        </span>
    );
}

export default BrandLogo;
